import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { scrollToId } from '../../utils/scroll';
import { transformationRows, transformationFooterStats } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-230" data-mp="2ffdpkivf2uhn">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-231" data-mp="2bfbx90bkndf1">
        <SectionTag icon="⚡" data-id="element-232" data-mp="2bh6g893a8vgh">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-233" data-mp="26nbpilp9fg7w">
          El entrenamiento termina, pero tu trabajo todavía no.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-234" data-mp="2z4we9do600lo">
          Llegas a casa y todavía tienes que preparar la próxima sesión. Buscas ejercicios, revisas videos,
          organizas las tareas y tratas de encontrar algo que realmente se adapte al nivel de tus
          jugadores.
        </p>

        <div className="mt-6 rounded-2xl border border-lime/20 bg-lime/5 p-5 text-left sm:p-6" data-id="element-235" data-mp="1a5y50rhkz7eo">
          <p className="font-heading text-sm font-semibold uppercase tracking-wide text-lime" data-id="element-236" data-mp="weta22p5r3ao">
            El problema real
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-237" data-mp="10fd8d9lgwcye">
            No es que te falten ejercicios. Es que muchas veces terminas reuniendo tareas sueltas sin una
            progresión que conecte un entrenamiento con el siguiente.
          </p>
        </div>

        <p className="mt-6 text-base leading-relaxed text-muted sm:text-lg" data-id="element-238" data-mp="dithoqs9pxqk">
          Con MISTER PRO puedes partir de sesiones organizadas, adaptar las tareas a tu equipo y dedicar
          más tiempo a observar, corregir y dirigir.
        </p>
        <p className="mt-3 text-sm font-medium text-lime sm:text-base" data-id="element-239" data-mp="2bwd3se3437wn">
          Menos tiempo buscando qué hacer. Más claridad sobre qué trabajar en cada entrenamiento.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-240" data-mp="3fuqf3eps6tpf">
        <div className="space-y-4" data-id="element-241" data-mp="3ft5mhun11ku7">
          {transformationRows.map((row, i) => <m.div key={row.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-2xl border border-white/10 bg-bg-secondary p-5 sm:p-6" data-id="element-242" data-mp="3bteyfyovxitd" data-mpi={i}>
              <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-243" data-mp="3urhkc4m4yzmy">
                {row.title} · {row.n}
              </p>
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-244" data-mp="3ps4vjebpfihq">
                <div className="flex items-start gap-3" data-id="element-245" data-mp="r364sdttvoqv">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-danger/15" data-id="element-246" data-mp="r4qwzwso6vlk">
                    <XIcon size={14} className="text-danger" data-id="element-247" data-mp="tn2icwthj617" />
                  </div>
                  <div data-id="element-248" data-mp="tpf7btxnugnr">
                    <p className="text-xs font-semibold uppercase tracking-wide text-danger" data-id="element-249" data-mp="ylnfgndfx9lf">Antes</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-250" data-mp="13kqlob55pluz">{row.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-251" data-mp="17oeusy9fspic">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success/15" data-id="element-252" data-mp="1cmgdhi2yamta">
                    <CheckIcon size={14} className="text-success" data-id="element-253" data-mp="1hjzsik7h33ma" />
                  </div>
                  <div data-id="element-254" data-mp="1mbhunbl8fa8u">
                    <p className="text-xs font-semibold uppercase tracking-wide text-success" data-id="element-255" data-mp="1mc9nieng2tvf">Ahora</p>
                    <p className="mt-1 text-sm leading-relaxed text-white" data-id="element-256" data-mp="1rab3gqpkqd2o">{row.after}</p>
                  </div>
                </div>
              </div>
            </m.div>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-257" data-mp="20c2emb2vvc3x">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-258" data-mp="1moabc9z78pua">Quiero dejar de improvisar</PrimaryButton>
        </div>

        <div className="mt-8" data-id="element-259" data-mp="1im5mdojp4hdz">
          <ScrollHintTable minWidth="480px" data-id="element-260" data-mp="1imylq4gbs4m3">
            <div className="grid grid-cols-3 divide-x divide-white/10" data-id="element-261" data-mp="1wf4wtc4mfleo">
              {transformationFooterStats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-3 py-6 text-center" data-id="element-262" data-mp="1rgts1ft6o13b">
                  <span className="font-heading text-xl font-bold text-lime sm:text-2xl" data-id="element-263" data-mp="13qg4a1hmsoej">{stat.value}</span>
                  <span className="text-xs text-muted sm:text-sm" data-id="element-264" data-mp="zq5ndtsawdkw">{stat.label}</span>
                </div>)}
            </div>
          </ScrollHintTable>
        </div>
      </div>
    </section>;
}